import React from 'react';
import './ChampionshipRegistrationModal.css';

interface ChampionshipRegistrationModalProps {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const ChampionshipRegistrationModal: React.FC<ChampionshipRegistrationModalProps> = ({
  open,
  title,
  subtitle,
  onClose,
  children,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="championship-registration-modal-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="championship-registration-modal" onClick={(event) => event.stopPropagation()}>
        <div className="championship-registration-modal-header">
          <div>
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Close registration dialog">
            ×
          </button>
        </div>
        <div className="championship-registration-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default ChampionshipRegistrationModal;
